export class ForgotPasswordDto {
  otpId?: string;
  userEnteredOtp?: string;
}